//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    pageMode: { type: String, default: '' },
    linksOverride: { type: Array, default: () => [] }
  },
  computed: {
    links () {
      if (this.linksOverride.length) return this.linksOverride

      if (this.pageMode === 'goggles') {
        // Goggles links
        return [{
          target: '/shop/goggles/vanguards',
          icon: 'sgi-vanguards',
          name: 'Vanguards™',
          subtitle: 'Bestseller',
          subtitleClass: 'orange'
        }, {
          target: '/shop/goggles/snipers',
          icon: 'sgi-snipers',
          name: 'Snipers™',
          subtitle: 'New'
        }, {
          target: '/shop/parts',
          icon: 'sgi-sniperslens',
          name: 'Lenses & Parts'
        }, {
          target: '/shop/cases/revoltcapsule',
          icon: 'sgi-gogglecapsule',
          name: 'Cases'
        }]
      } else if (this.pageMode === 'pace') {
        // Pace links
        return [{
          target: '/shop/sunglasses/vulcans',
          icon: 'sgi-vulcans-tf',
          name: 'Vulcans™'
        }, {
          target: '/shop/sunglasses/airas',
          icon: 'sgi-airas-zf',
          name: 'Airas™',
          subtitle: 'New'
        }, {
          target: '/shop/sunglasses/velans',
          icon: 'sgi-velans-tf',
          name: 'Velans™'
        }, {
          target: '/shop/parts/pace',
          icon: 'sgi-vcle-ff',
          name: 'Lenses & Parts'
        }, {
          target: '/shop/cases/pacecapsule',
          icon: 'sgi-sunglassescapsule',
          name: 'Cases'
        }]
      }

      // Sunglasses Links
      return [{
        target: '/shop/sunglasses/renegades',
        icon: 'sgi-renegades',
        name: 'Renegades™',
        subtitle: 'Bestseller',
        subtitleClass: 'orange'
      }, {
        target: '/shop/sunglasses/classics3',
        icon: 'sgi-classics2',
        name: 'Classics³'
      }, {
        target: '/shop/sunglasses/sierras',
        icon: 'sgi-sierras',
        name: 'Sierras™',
        subtitle: 'Upgraded'
      }, {
        target: '/shop/lenses',
        icon: 'sgi-sle2',
        name: 'Lenses & Parts'
      }, {
        target: '/shop/cases',
        icon: 'sgi-sunglassescapsule',
        name: 'Cases'
      }]
    }
  }
}
